// extracted by mini-css-extract-plugin
export default {"tabs":"h8-z","tablist":"i8-z","tablistItem":"j8-z"};